<template>
  <nav class="home-tabbar" :class="{'home-tabbar-bur': $i18n.locale === 'bur'}" :aria-label="$t('homeTabNavigation')">
    <button class="home-tabbar-side" :class="{active: active === 'winners'}" type="button" @click="openWinners">
      <img v-if="active === 'winners'" src="../../static/images/index/winners_act.png" alt="" />
      <img v-else src="../../static/images/index/winners.png" alt="" />
      <span>{{$t('homeWinners')}}</span>
    </button>
    <button class="home-tabbar-center" type="button" @click="$emit('select-box')" :aria-label="$t('homeLuckyBoxes')">
      <img v-if="active === 'boxes'" class="home-tabbar-gift" src="../../static/images/index/git_box_act.png" alt="" />
      <img v-else class="home-tabbar-gift" src="../../static/images/index/git_box.png" alt="" />
      <img v-if="available" class="home-tabbar-notice" src="../../static/images/index/noti.png" alt="" />
      <span v-if="available" class="home-tabbar-message">{{$t('homeLuckyAvailable')}}</span>
    </button>
    <button class="home-tabbar-side" :class="{active: active === 'profile'}" type="button" @click="openProfile">
      <img v-if="active === 'profile'" src="../../static/images/index/profile_act.png" alt="" />
      <img v-else src="../../static/images/index/profile.png" alt="" />
      <span>{{$t('homeProfile')}}</span>
    </button>
  </nav>
</template>

<script>
export default {
  props:{
    available:{type:Boolean,default:false},
    active:{type:String,default:'boxes'}
  },
  methods:{
    openWinners(){
      if(this.$route.path !== '/winnerList') this.$router.push({path:'/winnerList'})
    },
    openProfile(){
      if(this.$route.path !== '/profile') this.$router.push({path:'/profile'})
    }
  }
}
</script>

<style scoped>
  .home-tabbar{position:fixed;left:50%;bottom:0.14rem;z-index:900;width:91.2%;max-width:7rem;height:1.48rem;display:flex;align-items:flex-end;justify-content:space-between;padding:0 0.42rem 0.1rem;background:url(../../static/images/index/tab_bar_bg.png) no-repeat center bottom;background-size:100% 100%;transform:translateX(-50%);}
  .home-tabbar button{border:0;background:none;color:#d5d1ef;font-family:Atom-sans;}
  .home-tabbar-side{width:1.35rem;height:1.12rem;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0.02rem;font-size:0.29rem;}
  .home-tabbar-side img{width:0.48rem;height:0.48rem;object-fit:contain;}
  .home-tabbar-side:last-child > img{transform:translateY(-0.1rem);}
  .home-tabbar-side span{display:block;white-space:nowrap;line-height:1.1;}
  .home-tabbar-bur .home-tabbar-side span{font-size:0.24rem;letter-spacing:0;}
  .home-tabbar-side.active{color:#1feaf0;}
  .home-tabbar-center{position:relative;width:2.55rem;height:2.03rem;align-self:flex-end;display:flex;justify-content:center;align-items:flex-start;}
  .home-tabbar-gift{width:1.6rem;height:1.6rem;object-fit:contain;}
  .home-tabbar-notice{position:absolute;top:0.06rem;right:0.37rem;width:0.36rem;height:0.36rem;}
  .home-tabbar-message{position:absolute;bottom:-0.02rem;left:50%;box-sizing:border-box;width:3.05rem;height:0.68rem;padding:0.12rem 0.12rem 0;display:flex;align-items:center;justify-content:center;background:url(../../static/images/index/lucky_box_available.png) no-repeat center center;background-size:100% 100%;color:#fff;font-family:Atom-sans-bold;font-size:0.22rem;font-style:italic;line-height:1.1;text-align:center;transform:translateX(-50%);}
</style>



// WEBPACK FOOTER //
// src/components/HomeTabBar.vue